import {
  ProductCategoryResponse,
  CreateProductCategoryFormType,
  CreateProductCategoryResponse,
  DeleteProductCategoryRequestBody,
  DeleteProductCategoryResponse,
  EditProductCategoryFormType,
  EditProductCategoryResponse,
  CreateProductSubCategoryFormType,
  CreateProductSubCategoryResponse,
  EditProductSubCategoryFormType,
  EditProductSubCategoryResponse,
  DeleteProductSubCategoryRequestBody,
  DeleteProductSubCategoryResponse,
} from "src/pages/MasterData/ProductCategory/api/interfaces";
import API from ".";

const featureApiRoute = "/product-categories";
const subFeatureApiRoute = "/product-sub-categories";

export const getProductCategory =
  async (): Promise<ProductCategoryResponse> => {
    const response = await API.get<ProductCategoryResponse>(featureApiRoute);

    return response.data;
  };

export const createProductCategory = async (
  form: CreateProductCategoryFormType
): Promise<CreateProductCategoryResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.post<CreateProductCategoryResponse>(
    featureApiRoute,
    requestBody
  );

  return response.data;
};

export const editProductCategory = async ({
  id,
  ...form
}: EditProductCategoryFormType): Promise<EditProductCategoryResponse> => {
  const requestBody = {
    name: form.name,
    description: form.description,
  };

  const response = await API.put<EditProductCategoryResponse>(
    `${featureApiRoute}/${id}`,
    requestBody
  );

  return response.data;
};

export const deleteProductCategory = async ({
  id,
}: DeleteProductCategoryRequestBody): Promise<DeleteProductCategoryResponse> => {
  const response = await API.delete<DeleteProductCategoryResponse>(
    `${featureApiRoute}/${id}`
  );

  return response.data;
};

export const createProductSubCategory = async (
  form: CreateProductSubCategoryFormType
): Promise<CreateProductSubCategoryResponse> => {
  const requestBody = {
    product_category_id: form.productCategoryId,
    name: form.name,
    hex: form.color,
  };

  const response = await API.post<CreateProductSubCategoryResponse>(
    subFeatureApiRoute,
    requestBody
  );

  return response.data;
};

export const editProductSubCategory = async ({
  id,
  ...form
}: EditProductSubCategoryFormType): Promise<EditProductSubCategoryResponse> => {
  const requestBody = {
    product_category_id: form.productCategoryId,
    name: form.name,
    hex: form.color,
  };

  const response = await API.put<EditProductSubCategoryResponse>(
    `${subFeatureApiRoute}/${id}`,
    requestBody
  );

  return response.data;
};

export const deleteProductSubCategory = async ({
  id,
}: DeleteProductSubCategoryRequestBody): Promise<DeleteProductSubCategoryResponse> => {
  const response = await API.delete<DeleteProductSubCategoryResponse>(
    `${subFeatureApiRoute}/${id}`
  );

  return response.data;
};
